import React from 'react'

const Footer = () => {
  return (
    <div>
        <footer className="bg-black text-center md:mt-32 pt-4">
 
  <div className="text-center text-white md:p-4 " >
    © 2022 Copyright:
    <a className="text-white" href="https:gmail.com">Anmolsen73@gmail.com</a>
  </div>
</footer>
    </div>
  )
}

export default Footer
